module.exports = __webpack_public_path__ + "static/media/error.e885da3c.svg";